import * as types from '@/store/mutation-types/'
import * as apiTag from '@/api/tag'
import * as apiArt from '@/api/tag_art'
import * as api from '@/api/type'

/**
 * @param  {Function} options.commit
 * @param  {Object} request
 * @return {Promise}
 */
export const getTags = ({ commit }) => {
  apiTag.get()
    .then((res) => {
      commit(types.TAGS, res)
    })
  apiArt.get()
    .then((res) => {
      commit(types.TAGS_ART, res)
    })
}

/**
 * @param  {Function} options.commit
 * @param  {Object} request
 * @return {Promise}
 */
export const getWorkType = ({ commit }) => {
  api.getWorkMediaType()
    .then((res) => {
      commit(types.WORK_MEDIA_TYPE, res)
    })
  api.getWorkProjectType()
    .then((res) => {
      commit(types.WORK_PROJECT_TYPE, res)
    })
}

/**
 * @param  {Function} options.commit
 * @param  {Object} request
 * @return {Promise}
 */
export const getStoriesType = ({ commit }) => {
  api.getStoriesTag()
    .then((res) => {
      commit(types.STORIES_TAG, res)
    })
  api.getStoriesProjectType()
    .then((res) => {
      commit(types.STORIES_PROJECT_TYPE, res)
    })
}



// WEBPACK FOOTER //
// ./src/store/modules/options/actions.js